module.exports = __webpack_public_path__ + "img/partner8.11ab8f90.png";